import { animate, style, transition, trigger } from '@angular/animations';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { interval, Subject, takeUntil, tap } from 'rxjs';

@Component({
  selector: 'app-mock-call',
  templateUrl: './mock-call.component.html',
  styleUrls: ['./mock-call.component.scss'],
  animations: [
    trigger('fadePopup', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('200ms ease-out', style({ opacity: 1 })),
      ]),
      transition(':leave', [animate('200ms ease-in', style({ opacity: 0 }))]),
    ]),
  ],
})
export class MockCallComponent {
  @Input() popup!: any;
  @Output() closeEvent = new EventEmitter<void>();

  micOn = true;

  private destroy$ = new Subject<void>();
  private secondsElapsed = 0;
  formattedTime = '00:00';

  ngOnInit() {
    console.log('New Popup', this.popup);
    interval(1000)
      .pipe(
        takeUntil(this.destroy$),
        tap(() => {
          this.secondsElapsed++;
          const minutes = Math.floor(this.secondsElapsed / 60);
          const seconds = this.secondsElapsed % 60;
          this.formattedTime = `${this.pad(minutes)}:${this.pad(seconds)}`;
        })
      )
      .subscribe();
  }

  toggleMic() {
    this.micOn = !this.micOn;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private pad(num: number): string {
    return num.toString().padStart(2, '0');
  }
}
